import styles from "./index.module.css";
import TextArea from "shared/@forms/TextArea";
import Button, { ButtonPurpose } from "shared/Button";

import { useRefund } from "./useRefund";
import MoneyInput from "shared/@forms/MoneyInput";

export default function ({ iboNumber, order, onCancel }) {
  const { submit, isWaiting, reason, setReason, amount, setAmount } = useRefund(
    {
      iboNumber,
      order,
    }
  );

  return (
    <form
      className={styles.container}
      onSubmit={(e) => {
        e.preventDefault();
        submit();
      }}
    >
      <div className={styles.formGroup}>
        <h4 className={styles.formLabel}>Reason</h4>
        <TextArea
          value={reason}
          disabled={isWaiting}
          required={true}
          onChange={(e) => {
            setReason(e.target.value);
          }}
        />
      </div>

      <div className={styles.formGroup}>
        <h4 className={styles.formLabel}>Amount</h4>
        <MoneyInput
          value={amount}
          disabled={isWaiting}
          required={true}
          onChange={(value) => {
            setAmount(value);
          }}
        />
      </div>

      <div className={styles.actions}>
        <Button
          className={styles.formButton}
          disabled={isWaiting}
          purpose={ButtonPurpose.save}
        >
          Issue Refund
        </Button>

        <Button
          className={styles.formButton}
          onClick={(e) => {
            e.preventDefault();
            onCancel();
          }}
        >
          Cancel
        </Button>
      </div>
    </form>
  );
}
